import { concat } from 'lodash';
import React, { FC } from 'react';
import CreateForm from '../../../../../../../components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from '../../../../../../../context/ApplicationContext';
import { ALS_ERLEDIGT_MARKIEREN_LABEL, PLATZHALTER_TEXT } from '../../../../../../../lib/constants/constant';
import { FormStrucItem } from '../../../../../../../lib/types/types';
import { ForceTrue } from '../../../../../../../lib/validation/ValidationTypes';
import PruefAssistenz from '../../../../antrag-components/PruefAssistenz';
import ApplicationHeading from '../../../../application-heading/ApplicationHeading';
import { checkIfPruefAssitenzNeedsToValidate } from '../../../../application-helper-function/AppHelperfunctions';

// import schemas
import { checkReadOnlyInUeberarbeitung } from 'src/utils/helper';
import AntragSchema from '../../../../../../../lib/paths/antrag_FULL_Paths.json';
const P = AntragSchema.attributes;

const DurchfuehrungOrganisationAntragEPZ: FC<{ hasComment?: boolean }> = ({ hasComment }) => {
	const { application, setApplicationProperty, readOnly } = useApplication();
	const updatedReadOnly = checkReadOnlyInUeberarbeitung(application, readOnly, hasComment);

	return (
		<>
			<ApplicationHeading title='Lokaler Träger bzw. Durchführungsorganisation' description={PLATZHALTER_TEXT} />
			<PruefAssistenz
				statusPath={P.Projektbeschreibung_Entwicklungszusammenarbeit.schema.attributes.Pruefung_Durchfuehrungsorganisation_Pruefstatus.path}
				hinweisPath={
					P.Projektbeschreibung_Entwicklungszusammenarbeit.schema.attributes.Pruefung_Durchfuehrungsorganisation_Hinweis_Antragsteller.path
				}
				ueberarbeitetAmPath={
					P.Projektbeschreibung_Entwicklungszusammenarbeit.schema.attributes.Pruefung_Durchfuehrungsorganisation_Ueberarbeitet_Am.path
				}
				erledigtPath={P.Projektbeschreibung_Entwicklungszusammenarbeit.schema.attributes.Pruefung_Durchfuehrungsorganisation_Erledigt.path}
				formStruc={formStrucPruefAssistenz()}
			/>
			<CreateForm formStruc={formStruc()} formValues={application} updateFormValuesFunc={setApplicationProperty} readOnly={updatedReadOnly} />
		</>
	);
};

export default DurchfuehrungOrganisationAntragEPZ;

const formStrucPruefAssistenz = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Projektbeschreibung_Entwicklungszusammenarbeit.schema.attributes.Pruefung_Durchfuehrungsorganisation_Erledigt,
					label: ALS_ERLEDIGT_MARKIEREN_LABEL,
					validation: [{ validateFunction: ForceTrue }],
				},
			],
		},
	];
	return struc;
};
const formStruc = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				P.Projektbeschreibung_Entwicklungszusammenarbeit.schema.attributes.Name_Der_Partnerorganisation,
				P.Projektbeschreibung_Entwicklungszusammenarbeit.schema.attributes.Ansprechpartner_Fuer_Das_Projekt,
			],
			userProps: { direction: 'column', columnToDivide: 2 },
		},
		{
			fields: [P.Projektbeschreibung_Entwicklungszusammenarbeit.schema.attributes.Anschrift_Der_Partnerorganisation],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
		{
			fields: [
				{
					...P.Projektbeschreibung_Entwicklungszusammenarbeit.schema.attributes.Projektbeschreibung_Bisherigen_Zusammenarbeit,
					maxCharLength: 2000,
					placeholder: 'Wie ist die Partnerschaft entstanden? Gemeinsame Projekterfahrungen?',
				},
				{
					...P.Projektbeschreibung_Entwicklungszusammenarbeit.schema.attributes.Projektstandort,
					maxCharLength: 2000,
					placeholder: 'Beschreibung der Situation vor Ort, Erläuterung der Standortwahl',
				},
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
	return struc;
};

export const getFormStrucDurchfuehrungOrganisationAntragEPZ = (application: any) => {
	if (
		checkIfPruefAssitenzNeedsToValidate(
			application,
			P.Projektbeschreibung_Entwicklungszusammenarbeit.schema.attributes.Pruefung_Durchfuehrungsorganisation_Hinweis_Antragsteller.path,
			P.Projektbeschreibung_Entwicklungszusammenarbeit.schema.attributes.Pruefung_Durchfuehrungsorganisation_Erledigt.path,
		)
	)
		return concat(formStrucPruefAssistenz(), formStruc());
	return concat(formStruc());
};
